var Request = require('../../helper/request');

function Mention(app, feedId, commentId){
	var self = this;
	self.request = new Request(app);
	self.feedId = feedId;
	self.commentId = commentId;

	self.routes = {
		index: {
			url: '/feed/'+self.feedId+'/comment/'+self.commentId+'/mention',
			method: 'GET'
		},
		create: {
			url: '/feed/'+self.feedId+'/comment/'+self.commentId+'/mention',
			method: 'POST'
		},
		delete: {
			url: '/feed/'+self.feedId+'/comment/'+self.commentId+'/mention/:id',
			method: 'DELETE'
		}
	};
}

Mention.prototype.index = function(){
	var self = this;
	return self.request.get(self.routes.index.url);
}

Mention.prototype.create = function(data){
	var self = this;
	return self.request.post(self.routes.create.url, {
		mention: data
	});
}

Mention.prototype.delete = function(id){
	var self = this;
	var uri = self.routes.delete.url.replace(':id', id);
	return self.request.delete(uri);
}

module.exports = Mention;